<script>
  import { locale } from '../i18n';
  import { renderPublicContent } from '../content/publicSite.js';
  export let page = '';
</script>

<!-- All HTML is escaped by the renderer and comes from checked-in product copy. -->
{@html renderPublicContent(page, $locale)}
